import { FormattedMessage } from 'react-intl';

interface InjectMassageProps {
  id: string;
}

const InjectMessage = (props: InjectMassageProps): JSX.Element => <FormattedMessage {...props} />;

export default InjectMessage;
